import "pixi";
import "phaser";

import * as collision from "./collision";

export class Goal {
    game: Phaser.Game;
    goal: Phaser.Sprite;
    star: Phaser.Sprite;
    starTween: Phaser.Tween;
    hitPlayer: boolean;

    constructor(game: Phaser.Game, json: any, levelScale: number = 1) {
        let x = json.x * levelScale, y = json.y * levelScale;

        this.game = game;

        this.goal = this.game.add.sprite(x, y, "goal");
        this.star = this.game.add.sprite(0, -30, "star");
        this.goal.addChild(this.star);
        this.goal.width = 79;
        this.goal.height = 38;

        this.game.add.tween(this.goal).to({
            alpha: 0.5,
        }, 1500, Phaser.Easing.Cubic.InOut).loop().yoyo(true).start();

        this.starTween = this.game.add.tween(this.star).to({
            y: -15,
        }, 1500, Phaser.Easing.Cubic.InOut).loop().yoyo(true).start();

        this.game.physics.p2.enable(this.goal);

        this.goal.body.setRectangle(
            60, 24, 0, 8
        );
        this.goal.body.static = true;
        this.star.body.destroy();
    }

    // Is the player on the goal?
    reachedGoal(player: collision.AABBLike): boolean {
        if (Phaser.Math.distance(player.x+player.width/2, player.y+player.height/2, this.goal.body.x, this.goal.body.y) <= 35){
            this.goal.tint = 0x00FF00;
            return true;
        }
        this.goal.tint = 0xFFFFFF;
        return false;
    }

    get body(): Phaser.Physics.P2.Body {
        return this.goal.body;
    }

    get displayObject(): PIXI.DisplayObject {
        return this.goal;
    }

    translate(dx: number, dy: number): void {
        this.goal.body.x += dx;
        this.goal.body.y += dy;
    }

    get aabb(): collision.AABBLike {
        return { x: this.goal.body.x - 30,
                 y: this.goal.body.y - 12 + 8,
                 width: 60,
                 height: 24 };
    }

    constrainTranslation(
        offsetX: number, offsetY: number,
        dx: number, dy: number,
        bbox: collision.AABBLike,
    ): [number, collision.ConstraintDirection[]] {
        let aabb = this.aabb;
        aabb.x += offsetX;
        aabb.y += offsetY;
        return collision.constrainAABBTranslation(
            aabb,
            dx, dy,
            bbox
        );
    }

    intersects(line: collision.Line): boolean {
        return line.intersectsAABB(this.aabb);
    }

    whichSide(line: collision.Line): collision.LineSide {
        return line.whichSide(this.aabb);
    }

    highlightIntersection(highlight: boolean): void {
        this.goal.tint = highlight ? 0xFF0000 : 0xFFFFFF;
    }

    serialize(): any {
        return {
            x: this.goal.position.x,
            y: this.goal.position.y,
        };
    }

    serializeMutable(): any {
        return {
            x: this.goal.position.x,
            y: this.goal.position.y,
        };
    }

    deserializeMutable(json: any, levelScale: number = 1): void {
        this.goal.body.x = json.x * levelScale;
        this.goal.body.y = json.y * levelScale;
    }

    detachStar(): Phaser.Sprite {
        this.starTween.stop();
        const absPos = this.star.worldPosition;
        this.star.parent.removeChild(this.star);
        this.game.world.addChild(this.star);
        this.star.x = absPos.x;
        this.star.y = absPos.y;
        return this.star;
    }
}



// WEBPACK FOOTER //
// ./src/goal.ts